export default function createRequestAttributesObject(
  stackId,
  userId,
  hostname,
  lang_override,
  chat_context,
  lead_context,
) {
  return {
    // defaults to MagicForm website stack
    stack_id: stackId,
    user_id: userId,
    hostname: hostname ? hostname : "",
    lang_override: lang_override,
    chat_context: chat_context,
    lead_context: lead_context,
  };
}
